<!-- <app-master-navbar></app-master-navbar> --><app-nav-logo></app-nav-logo>



<div class="container p-5 mt-3">
    <div class="row">
        <div class="col-lg-12 text-center mb-3">
            <h4>ข้อมูลสหกรณ์ จังหวัด {{provinceName}} </h4>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3"
            *ngIf="CoopStatusProvinceYearBySearch != '' &&
            CoopStatusProvinceYearBySearch
            != undefined">
            <p class="text-right mt-5 mb-1">จำนวนผลลัพธ์การค้นหา : {{sumResult}}</p>
            <div class="card">
                <div class="card-header p-2">
                    <div class="row">
                        <div class="col-lg-8 col-md-12 col-sm-12">
                            <p class="m-0">รายชื่อจังหวัด</p>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <h6 class="text-black-50 text-right" *ngIf="datayear
                                !=
                                undefined">ข้อมูล ณ ปี
                                {{ year_now }}</h6>
                        </div>
                    </div>
                </div>
                <div class="card-body p-5">
                    <table class="table table-hover">
                        <thead>
                            <tr class="text-center">
                                <th colspan="6" class="th-p">
                                    <i class="fas fa-map-marked-alt"></i>
                                    {{phakName}}
                                </th>
                            </tr>
                            <tr class="table-active">
                                <th scope="col">จังหวัด</th>
                                <th scope="col">Active</th>
                                <th scope="col">Non - Active</th>
                                <th scope="col">รวม</th>
                                <th class="text-center" scope="col">รายชื่อสหกรณ์ในจังหวัด</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let items of
                            CoopStatusProvinceYearBySearch; index as i">
                            <tr>
                                <th scope="row">{{items.provinceName}}</th>
                                <td>{{items.active}}</td>
                                <td>{{items.nonActive}}</td>
                                <td>{{items.sum}}</td>
                                <td class="text-center">
                                    <button class="btn
                                        btn-info"
                                        (click)="selectProvice_Search()">
                                        <i class="fas fa-search"></i>
                                        ดูเพิ่มเติม</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5"
            *ngIf="selectProviceSearch == true">
            <p class="text-right mt-5 mb-1">จำนวนผลลัพธ์การค้นหา :
                {{sumResult_}}</p>
            <div class="card">
                <div class="card-header p-2">
                    <div class="row">
                        <div class="col-lg-8 col-md-12 col-sm-12">
                            <p class="m-0">รายชื่อสหกรณ์</p>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <h6 class="text-black-50 text-right" *ngIf="datayear
                                !=
                                undefined">ข้อมูล ณ ปี
                                {{ year_now }}</h6>
                        </div>
                    </div>
                </div>
                <div class="card-body p-5">
                    <div class="form-group row">
                        <div class="col-lg-12 col-md-12 col-sm-12 d-flex
                            mb-3">
                            <label for="inputPassword" class="col-sm-2
                                col-form-label">ค้นหารายการ</label>
                            <div class="col-sm-10">
                                <input class="form-control w-75"
                                    type="text"
                                    name="search"
                                    [(ngModel)]="searchText">
                            </div>
                        </div>
                    </div>
                    <table class="table table-hover">
                        <thead>
                            <tr class="text-center">
                                <th colspan="6" class="th-p">
                                    <i class="fas fa-map-marked-alt"></i>
                                    {{phakName}}
                                </th>
                            </tr>
                            <tr class="table-active">
                                <th width="30%">ชื่อสหกรณ์</th>
                                <th scope="col">สมาชิก เพศชาย</th>
                                <th scope="col">สมาชิก เพศหญิง</th>
                                <th scope="col">สมาชิกสหกรณ์ ทั้งหมด</th>
                                <th scope="col">เพิ่มเติม</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let items of
                                listCoop | filter:searchText">
                                <th scope="row">{{items.coopNameTh}}</th>
                                <td>{{items.memberFm}}</td>
                                <td>{{items.memberM}}</td>
                                <td>{{items.member}}</td>
                                <td>
                                    <button class="btn btn-info"
                                        (click)="selectCoopProfile($event.target.value)"
                                        id="{{items.coopId}}"
                                        value="{{items.coopId}}">
                                        <i class="fas fa-search"></i>
                                        ดูเพิ่มเติม</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 d-none"
            *ngIf="CoopStatusProvinceYearOne != '' && CoopStatusProvinceYearOne
            != undefined">
            <div class="card">
                <div class="card-body p-0">
                    <table class="table table-hover">
                        <thead>
                            <tr class="text-center">
                                <th colspan="6" class="th-p">
                                    <i class="fas fa-map-marked-alt"></i>
                                    {{phakName}}
                                </th>
                            </tr>
                            <tr class="table-active">
                                <th scope="col">จังหวัด</th>
                                <th scope="col">Active</th>
                                <th scope="col">Non - Active</th>
                                <th scope="col">รวม</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let items of
                                CoopStatusProvinceYearOne;"
                                (click)="selectProvice_Search()">
                                <th scope="row">{{items.provinceName}}</th>
                                <td>{{items.active}}</td>
                                <td>{{items.nonActive}}</td>
                                <td>{{items.sum}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default"
    type="ball-spin-clockwise">
    <p style="color: white">กรุณารอสักครู่. </p>
</ngx-spinner>
